import './ui/styles.css';
import { start } from './ui/app';

void start(document.getElementById('app')!);
